import React from 'react'
import { Head, prefetch } from 'react-static'
import PropTypes from 'prop-types'
import { TweenMax } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin' // eslint-disable-line

import HomeHeader from './HomeHeader'
import Slideshow from '../../containers/Slideshow'
import HomeServices from './HomeServices'
import HomeAbout from './HomeAbout'
import HomeBlog from './HomeBlog'
import ContactPanel from '../ContactPanel'
import Footer from '../Footer'
import Loader from '../../containers/Loader'

import '../../styles/home/home.scss'

export default class Home extends React.Component {
  static propTypes = {
    headerHeight: PropTypes.number.isRequired,
    posts: PropTypes.array.isRequired,
    slides: PropTypes.array.isRequired,
  }

  constructor (props) {
    super(props)
    this.state = {
      headerBg: false,
      activeNavItem: 'home',
      navItems: ['home', 'services', 'latest', 'about'],
    }
    this.sections = {}
    this.headerHeight = props.headerHeight
    this.latestOffset = 0
    this.servicesOffset = 0
    this.aboutOffset = 0
    this.windowHeight = 0
    this.scrolling = false
    this.offsetsCalculated = false
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.calculateOffsets)
    window.scrollTo(0, 0)
  }

  componentWillReceiveProps (next) {
    if (next.headerHeight !== this.props.headerHeight) {
      this.headerHeight = next.headerHeight
    }

    if (next.loaderHidden && next.loaderHidden !== this.props.loaderHidden) {
      setTimeout(this.prefetchRoutes,2000)
    }
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.calculateOffsets)
  }

  addListeners = async () => {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.calculateOffsets)
  }

  calculateOffsets = () => {
    if (!this.offsetsCalculated) {
      this.offsetsCalculated = true
    }
    const sectionList = this.state.navItems.slice(1)
    for (let i = 0, l = sectionList.length; i < l; i++) {
      const el = document.querySelector(`.home-${sectionList[i]}`)
      this.sections[sectionList[i]] = el
    }
    this.windowHeight = window.innerHeight
    this.latestOffset = this.sections.latest.offsetTop - this.headerHeight
    this.servicesOffset = this.sections.services.offsetTop - this.headerHeight
    this.aboutOffset = this.sections.about.offsetTop - this.headerHeight
    this.handleScroll()
  }

  handleScroll = () => {
    this.updateHeaderBg()
    this.updateNavLocation()
  }

  updateHeaderBg = () => {
    const { headerBg } = this.state
    const slideshow = document.querySelector('.home-slideshow')
    const services = document.querySelector('.home-services')
    const offsetTop = services.getBoundingClientRect().top - slideshow.getBoundingClientRect().height
    if (offsetTop <= -50 && !headerBg) {
      this.setState({ headerBg: true })
    }
    if (offsetTop > -50 && headerBg) {
      this.setState({ headerBg: false })
    }
  }

  updateNavLocation = () => {
    if (!this.offsetsCalculated) {
      this.calculateOffsets()
    }
    if (this.scrolling) return

    const { activeNavItem } = this.state
    const offsetTop = document.body.getBoundingClientRect().top * -1
    const footerBottom = document.querySelector('.footer-bottom').getBoundingClientRect().top

    if (offsetTop < this.servicesOffset - 2 && activeNavItem !== 'home') {
      return this.setState({ activeNavItem: 'home' })
    }
    if (offsetTop >= this.servicesOffset - 2 && offsetTop < this.latestOffset - 2 && activeNavItem !== 'services') {
      return this.setState({ activeNavItem: 'services' })
    }
    if (offsetTop >= this.latestOffset - 2 && offsetTop < this.aboutOffset - 2 && activeNavItem !== 'latest') {
      return this.setState({ activeNavItem: 'latest' })
    }
    if ((offsetTop >= this.aboutOffset - 2 && activeNavItem !== 'about') || footerBottom <= this.windowHeight) {
      return this.setState({ activeNavItem: 'about' })
    }
  }

  scrollToSection = section => {
    if (!this.offsetsCalculated) {
      this.calculateOffsets()
    }
    let offset
    if (section === 'home') {
      offset = 0
    } else {
      offset = document.querySelector(`.home-${section}`).offsetTop - this.headerHeight + 2
    }
    this.scrolling = true
    this.setState({ activeNavItem: section })
    TweenMax.to(window, 0.8, { scrollTo: offset })
    setTimeout(this.resetActiveNavItem, 800)
  }

  resetActiveNavItem = () => {
    this.scrolling = false
  }

  prefetchRoutes = () => {
    prefetch('/blog')
    prefetch('/contact')
  }

  render () {
    const { headerBg, activeNavItem, navItems } = this.state
    const { posts, slides, loaderHidden } = this.props
    return (
      <div className={headerBg ? 'home header-bg' : 'home'}>
        <Head>
          <meta description="Residential and commercial roofing experts. Makuch Roofing provides a full range of roofing services across the Waikato, Bay of Plenty and Auckland regions. From large scale commercial buildings to new homes, roof replacements and guttering. No job is too big or too small." />
          <link rel="canonical" href="https://makuchroofing.co.nz" />
          <title>Home</title>
        </Head>
        <Slideshow slides={slides} />
        { loaderHidden && <HomeHeader
            scrollToSection={this.scrollToSection}
            navItems={navItems}
            activeNavItem={activeNavItem}
            updateHeaderBg={this.updateHeaderBg}
          /> }
        <HomeServices loaderHidden={loaderHidden} />
        <ContactPanel isContact={false} />
        <HomeBlog loaderHidden={loaderHidden} posts={posts} />
        <HomeAbout loaderHidden={loaderHidden} />
        <Footer />
        { !loaderHidden && <Loader /> }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/home-page/Home.js